<template>
  <div>
    <b-card v-if="series2[0].data && chartOptions2.xaxis.categories">
      <b-row class="mx-1">
        <b-form-datepicker id="from-datepicker" v-model="fromDate" class="mb-2 mr-1 col" placeholder="Επιλέξτε Ημερομηνία"
          :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: '2-digit',
            }" locale="el-GR" @input="getAttendance(this.fromDate, this.toDate)"></b-form-datepicker>
        <b-form-datepicker id="to-datepicker" v-model="toDate" class="mb-2 ml-1 col" placeholder="Επιλέξτε Ημερομηνία"
          :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: '2-digit',
            }" locale="el-GR" @input="getAttendance(this.fromDate, this.toDate)"></b-form-datepicker>
      </b-row>
      <hr />
      <apexchart type="line" height="350" :options="chartOptions2" :series="series2"></apexchart>
    </b-card>
    <b-card v-else>
      <b-spinner label="Loading..."></b-spinner>
    </b-card>
  </div>
</template>

<script>
// import ApexChart from "vue-apexcharts";
import EsepService from "../../services/esep.service";
import { prettifyDate } from "../../services/utils";
import { handleApiError } from "../../services/error.service";

export default {
  components: {
    // ApexChart
  },
  props: {
    branch: String,
    unitId: Number
  },
  watch: {
    branch(newVal) {
      this.selectedBranch = newVal;
      this.getAttendance(this.fromDate, this.toDate);
    },
    unitId(newUnitId) {
      this.selectedUnitId = newUnitId;
      this.getAttendance();
    },
    fromDate(newDate) {
      this.getAttendance(newDate, this.toDate);
    },
    toDate(newDate) {
      this.getAttendance(this.fromDate, newDate)
    }
  },
  mounted() {
    this.fromDate = this.$store.state.currentCensusPeriod.startDate;
    this.toDate = this.$store.state.currentCensusPeriod.endDate;
    this.getAttendance(this.fromDate, this.toDate)
  },
  data() {
    return {
      fromDate: null,
      toDate: null,
      selectedBranch: 'CUB',
      selectedUnitId: this.unitId || Number(this.$store.state.globalUnitId) || this.$store.state.userInfo.orgMember.orgUnit.id,
      orderBy: 'startDate',
      series2: [
        {
          name: "Συμμετοχή",
          data: null,
        },
      ],
      chartOptions2: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        title: {
          text: "Συμμετοχή στις Δράσεις",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: null,
        },
      },
    };
  },
  methods: {
    getAttendance(fromDate, toDate) {
      this.chartOptions2.xaxis.categories = null;
      this.series2[0].data = null;

      EsepService.getAttendanceReport(fromDate, toDate, this.selectedUnitId, this.selectedBranch, this.orderBy).then(
        (response) => {
          let data = []
          let categories = []
          this.$log.debug('attendance report:')
          this.$log.debug(response.data)
          response.data.content.forEach(exc => {
            data.push(exc.attendance);
            categories.push(prettifyDate(exc.startDate))
          });

          this.series2[0].data = data;
          this.chartOptions2.xaxis.categories = categories;
        },
        (error) => {
          if (error.response.status % 100 === 4) {
            this.$emit('show-comp', { name: 'achievements', value: false });
          } else {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
        }
      )
    }
  },
};
</script>

<style></style>
